<div class="page-content-small page-fill d-flex flex-column">
    <div *ngIf="confirmations" class="d-flex">
        <div class="column ms-2 me-2"><span class="color-legend waiting-on-dealer-order"></span> - Waiting on Dealer-Order</div>
        <div class="column ms-2 me-2"><span class="color-legend waiting-on-dealer-ach"></span> - Waiting on Dealer-ACH</div>
        <div class="column ms-2 me-2"><span class="color-legend waiting-on-ach-deposit"></span> - Waiting on ACH Deposit/NP or Red Oak Verification</div>
        <div class="column ms-2 me-2"><span class="color-legend approved-to-acknowledge"></span> - Approved</div>
        <div class="column ms-2 me-2"><span class="color-legend declined-to-acknowledge"></span> - Declined</div>
        <div class="column ms-2 me-2"><span class="color-legend declined-requesting-changes"></span> - Requesting Changes</div>
        <!-- <div class="column ms-2 me-2"><span class="color-legend approved-winter-to-acknowledge"></span> - Winter Order Approved</div> -->
    </div>
    <div class="flex-fill d-flex flex-column">
        <div class="m-1 grid-fill" *ngIf="confirmations">
            <dx-data-grid
                #dataGrid
                keyExpr="id"
                [dataSource]="confirmations"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onSelectionChanged)="selectionChange($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onExporting)="onExporting($event)"
            >
                <dxi-column dataField="code" width="255" cellTemplate="codeTemplate"></dxi-column>
                <dxi-column dataField="order.invoiceNumber" caption="Sales Order #" cellTemplate="linkTemplate" width="80"></dxi-column>
                <dxi-column dataField="order.type.name" caption="Order Type" width="90"></dxi-column>
                <dxi-column dataField="dealer.companyName" caption="Dealer" width="200" cellTemplate="dealerLinkTemplate"></dxi-column>
                <dxi-column dataField="type.name" caption="Type" width="80"></dxi-column>
                <dxi-column dataField="created" caption="Created" width="100" [sortIndex]="0" sortOrder="desc"></dxi-column>
                <dxi-column dataField="viewed" format="shortDateShortTime" width="100"></dxi-column>
                <dxi-column dataField="approved" format="shortDateShortTime" width="100"></dxi-column>
                <dxi-column dataField="declined" format="shortDateShortTime" width="100"></dxi-column>
                <dxi-column dataField="confirmedBy" width="100"></dxi-column>
                <dxi-column dataField="confirmationPaymentMethod.name" caption="Payment Method" width="100"></dxi-column>
                <dxi-column dataField="order.total" caption="Order Total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="cancelReason" width="100"></dxi-column>
                <dxi-column dataField="notes" width="100"></dxi-column>
                <dxi-column dataField="requestedSalesRepContact" caption="Contact Dealer" width="100"></dxi-column>
                <dxi-column dataField="order.dealer.salesRep.name" caption="Sales Rep" width="80"></dxi-column>
                <dxi-column dataField="acknowledged" width="100"></dxi-column>
                <dxi-column dataField="acknowledgedBy" width="100"></dxi-column>
                <dxi-column dataField="message" width="400"></dxi-column>
                <dxi-column dataField="id" width="50"></dxi-column>
                <dxi-column width="20"></dxi-column>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="open(cell.data.orderId)">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                    <a [routerLink]="['/dealers/overview/' + cell.data.dealerId]">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'codeTemplate'">
                    <a [routerLink]="[]" (click)="viewConfirmation(cell.data.code)">{{ cell.value }}</a>
                </div>


                <dxo-summary>
                    <dxi-total-item column="order.total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                </dxo-summary>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="confirmations-overview-grid"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-success" (click)="resetLink(dataGrid.instance.getSelectedRowsData())" [disabled]="dataGrid.instance.getSelectedRowsData()?.length === 0">
                        Reset Link
                    </button>
                    <button class="btn btn-success ms-4" (click)="acknowledge()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Acknowledge</button>
                    <button
                        class="btn btn-success ms-4"
                        (click)="print(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Print
                    </button>
                    <button class="btn btn-danger ms-2" (click)="delete()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Delete</button>
                    <button class="btn btn-sm btn-warning ms-4" (click)="toggleShowAll()">{{ filter.showAll ? 'Hide Acknowledged' : 'Show All' }}</button>
                    <button class="btn btn-sm btn-secondary ms-2" (click)="getData()">Refresh Data</button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="confirmations" class="me-3"
                        ><strong
                            >{{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong></span
                    >
                </div>


            </dx-data-grid>
        </div>
    </div>
</div>
